// extracted by mini-css-extract-plugin
module.exports = {"pagination_wrapper":"Pagination_pagination_wrapper__1EJrS","prev":"Pagination_prev__2xxbr","next":"Pagination_next__kb8bl","active":"Pagination_active__S-Btt"};